import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc94c3c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ub ub-ac ub-pc" }
const _hoisted_2 = { style: {"display":"flex","position":"relative","justify-content":"center"} }
const _hoisted_3 = {
  class: "btn-list",
  ref: "tableShowBtnRef"
}
const _hoisted_4 = { class: "trigger-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_show_button = _resolveComponent("show-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_show_button, {
          "biz-type": _ctx.bizType,
          record: _ctx.record,
          showLostOrderBtn: _ctx.showLostOrderBtn,
          bizId: _ctx.bizId,
          bizName: _ctx.bizName,
          loading: _ctx.loading,
          examineAccess: _ctx.examineAccess,
          showVoidBtn: _ctx.showVoidBtn,
          showCancelBtn: _ctx.showCancelBtn,
          existRelation: _ctx.existRelation,
          showRejectBtn: _ctx.showRejectBtn,
          showAgreeBtn: _ctx.showAgreeBtn,
          showSubmitBtn: _ctx.showSubmitBtn,
          path: _ctx.path,
          viewPath: _ctx.viewPath,
          showEditFlg: _ctx.showEditFlg,
          onRefreshApprovalDetail: _ctx.refreshApprovalDetail
        }, null, 8, ["biz-type", "record", "showLostOrderBtn", "bizId", "bizName", "loading", "examineAccess", "showVoidBtn", "showCancelBtn", "existRelation", "showRejectBtn", "showAgreeBtn", "showSubmitBtn", "path", "viewPath", "showEditFlg", "onRefreshApprovalDetail"])
      ], 512),
      (_ctx.isShowDrop)
        ? (_openBlock(), _createBlock(_component_a_dropdown, {
            key: 0,
            getPopupContainer: _ctx.getContainer
          }, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, { class: "btn-menu" }, {
                default: _withCtx(() => [
                  _createVNode(_component_show_button, {
                    "biz-type": _ctx.bizType,
                    record: _ctx.record,
                    showLostOrderBtn: _ctx.showLostOrderBtn,
                    bizId: _ctx.bizId,
                    bizName: _ctx.bizName,
                    loading: _ctx.loading,
                    examineAccess: _ctx.examineAccess,
                    showVoidBtn: _ctx.showVoidBtn,
                    showCancelBtn: _ctx.showCancelBtn,
                    existRelation: _ctx.existRelation,
                    showRejectBtn: _ctx.showRejectBtn,
                    showAgreeBtn: _ctx.showAgreeBtn,
                    showSubmitBtn: _ctx.showSubmitBtn,
                    path: _ctx.path,
                    viewPath: _ctx.viewPath,
                    showEditFlg: _ctx.showEditFlg,
                    onRefreshApprovalDetail: _ctx.refreshApprovalDetail
                  }, null, 8, ["biz-type", "record", "showLostOrderBtn", "bizId", "bizName", "loading", "examineAccess", "showVoidBtn", "showCancelBtn", "existRelation", "showRejectBtn", "showAgreeBtn", "showSubmitBtn", "path", "viewPath", "showEditFlg", "onRefreshApprovalDetail"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_svg_icon, {
                  "icon-class": "morebtn",
                  size: "12"
                })
              ])
            ]),
            _: 1
          }, 8, ["getPopupContainer"]))
        : _createCommentVNode("", true)
    ])
  ]))
}